import { fetchWithCache, getCachedData } from "../services/apiService";

export const commentReportedGet = async () => {
  // Show cached data immediately if available
  const cached = getCachedData("/api/comment/reportedComments", {});
  if (cached) {
    return cached;
  }

  try {
    const data = await fetchWithCache(
      "/api/comment/reportedComments",
      {
        method: "GET",
        retries: 2,
        timeout: 10000,
      },
      true,
    );

    // If response has an error field, return empty array
    if (data && data.error) {
      return [];
    }

    // Ensure we return an array
    return Array.isArray(data) ? data : [];
  } catch (err) {
    // Return cached data on error, or empty array
    return cached || [];
  }
};
